// src/screens/components/Equipos.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function Equipos({ equipos = [], mensaje, onInforme }) {
  // Función auxiliar para la clase de estado
  const getEstadoClass = desc =>
    desc?.trim().toLowerCase() === 'inactivo'
      ? 'border-red-300'
      : 'border-blue-200';

  return (
    <section>
      <h2 className="text-2xl font-bold mb-6">Equipos disponibles</h2>

      {mensaje && <p className="text-red-500 mb-6">{mensaje}</p>}

      {equipos.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-7 mb-8">
          {equipos.map(equipo => (
            <div
              key={equipo.moduloId}
              className="relative p-5 rounded-2xl border border-[#dbeafe] bg-white/90 shadow-md hover:shadow-xl hover:ring-2 hover:ring-blue-300 transition-all duration-200 flex flex-col min-h-[240px]"
            >
              {/* Título y estado */}
              <div className="flex justify-between items-center mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-lg text-sm font-bold shadow">
                  {equipo.moduloNombre}
                </span>
                <div
                  className={`border-2 rounded-xl px-3 py-1 text-sm font-semibold text-blue-800 ${getEstadoClass(
                    equipo.estadoDescripcion
                  )}`}
                >
                  {equipo.estadoDescripcion}
                </div>
              </div>

              {/* Ícono decorativo */}
              <div className="flex justify-center mb-6">
                <span
                  className="text-blue-200"
                  style={{ fontSize: '3rem', opacity: 0.17 }}
                >
                  💧
                </span>
              </div>

              <div className="flex-grow" />

              {/* Botones de acciones */}
              <div className="flex flex-wrap justify-center gap-3">
                <Link
                  to={`/sector/${equipo.moduloId}`}
                  state={{ equipo }}
                  className="bg-gradient-to-r from-blue-400 to-cyan-400 text-white px-4 py-1.5 rounded-full text-xs font-semibold shadow hover:from-blue-500 hover:to-cyan-500 transition w-full sm:w-auto text-center"
                >
                  Ver Sectores
                </Link>
                <Link
                  to={`/programacion/${equipo.moduloId}`}
                  state={{ equipo }}
                  className="bg-gradient-to-r from-blue-400 to-cyan-400 text-white px-4 py-1.5 rounded-full text-xs font-semibold shadow hover:from-blue-500 hover:to-cyan-500 transition w-full sm:w-auto text-center"
                >
                  Programación
                </Link>
                <button
                  onClick={() => onInforme(equipo)}
                  className="bg-gradient-to-r from-blue-400 to-cyan-400 text-white px-4 py-1.5 rounded-full text-xs font-semibold shadow hover:from-blue-500 hover:to-cyan-500 transition w-full sm:w-auto text-center"
                >
                  Informe
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 mb-6">No se encontraron equipos en este campo.</p>
      )}
    </section>
  );
}
